import React from 'react';
import { Box, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { setEnvironmentAction } from '../appRedux/actions/environment';

const EnvironmentSwitcher = () => {
  const dispatch = useDispatch();
  const environmentState = useSelector((state) => state.environment);
  
  const currentEnvironment = environmentState.currentEnvironment;
  const environments = environmentState.environments;

  const handleEnvironmentChange = (event) => {
    dispatch(setEnvironmentAction(event.target.value));
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <FormControl size="small" fullWidth>
        <InputLabel id="environment-select-label">Environment</InputLabel>
        <Select
          labelId="environment-select-label"
          value={currentEnvironment}
          label="Environment"
          onChange={handleEnvironmentChange}
        >
          {Object.entries(environments).map(([key, env]) => (
            <MenuItem key={key} value={key}>
              {env.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default EnvironmentSwitcher; 